export const defaultLocale = "en";
export const maximumProcessableCommands = 100;
export var CommandName;
(function (CommandName) {
    CommandName["createOnPageDialog"] = "create_on_page_dialog";
    CommandName["createTab"] = "create_tab";
    CommandName["deleteCommands"] = "delete_commands";
})(CommandName || (CommandName = {}));
export const CommandVersion = {
    [CommandName.createOnPageDialog]: 8,
    [CommandName.createTab]: 6,
    [CommandName.deleteCommands]: 100,
};
export var CommandEventType;
(function (CommandEventType) {
    CommandEventType["expired"] = "command_expired";
})(CommandEventType || (CommandEventType = {}));
